import { render, staticRenderFns } from "./customField.vue?vue&type=template&id=237fb24a&scoped=true"
import script from "./customField.vue?vue&type=script&lang=js"
export * from "./customField.vue?vue&type=script&lang=js"
import style0 from "./customField.vue?vue&type=style&index=0&id=237fb24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237fb24a",
  null
  
)

export default component.exports